module.exports = __webpack_public_path__ + "static/mixta-black-3c29d3fb9bfa18a025868c7aed14cccf.otf";